import { ApiCallsFactory, LocalPersistence } from '../../../factories'

declare global {
  interface Window {
    otherAmenitiesRenovationsBody: { 
      roomrenovationyear: string, 
      roomrenovationnumbers: string, 
      roomrenovationpercent: string
    },
    otherAmenitiesRatesViewBody: {
      dayrateavail: string,
      dayratecost: string,
      dayrateprop: string,
      dayratenote: string
    },
    otherAmenitiesMiscellaneousBody: {
      guestlaundry: string,
      guestlaundryfee: string,
      guestlaundryhours: any,
      foodtakeaway: string, 
      ccaccessavail: string,
      ccaccesscost: string,  
      ccaccessprop: string,
      ccaccessnotes: string,
      cribavail: string,
      cribcost: string,
      cribprop: string,
      cribnotes: string
    },
    otherAmenitiesExtra: {
      accessiblewashbasin: string,
      loweredsink: string,
      loweredviewportdoor: string
    },
    otherAmenitiesGeneral: {
      roomentrance: string,
      airfilter: string,
      hypoallergicroom: string,
      housekeepingtype: string,
      housekeepingfrequency: string,
      housekeepingdailyfee: string
    },
    otherAmenitiesHotelBody: {
      startdate: string,
      enddate: string
    },
    otherAmenityGet: {
      roomrenovationyear: string
      roomrenovationnumbers: string,
      roomrenovationpercent: string,
      dayrateavail: string,
      dayratecost: string,
      dayrateprop: string,
      dayratenote: string,
      guestlaundry: string,
      guestlaundryfee: string,
      guestlaundryhours: any,
      frontdeskhours: any,
      foodtakeaway: string,
      ccaccessavail: string,
      ccaccesscost: string,
      ccaccessprop: string,
      ccaccessnotes: string,
      cribavail: string,
      cribcost: string,
      cribprop: string,
      cribnotes: string,
      accessiblewashbasin: string,
      loweredsink: string,
      loweredviewportdoor: string,
      roomentrance: string,
      airfilter: string,
      hypoallergicroom: string,
      housekeepingtype: string,
      housekeepingfrequency: string,
      housekeepingdailyfee: string,
      closures: any,
      otheramenityid: number
    }
  }
}

const post = async () => {
  const get_session = new LocalPersistence('session')
  const session: any = await get_session.getSessionPersistence()
  const body = {
    "supplier": session.supplier,
    "propertyId": session.propertyId,
    "property":{
       "otheramenities":{
          "roomrenovationyear": window.otherAmenitiesRenovationsBody ? window.otherAmenitiesRenovationsBody.roomrenovationyear : window.otherAmenityGet.roomrenovationyear,
          "roomrenovationnumbers": window.otherAmenitiesRenovationsBody ? window.otherAmenitiesRenovationsBody.roomrenovationnumbers : window.otherAmenityGet.roomrenovationnumbers,
          "roomrenovationpercent": window.otherAmenitiesRenovationsBody ? window.otherAmenitiesRenovationsBody.roomrenovationpercent : window.otherAmenityGet.roomrenovationpercent,
          "dayrateavail": window.otherAmenitiesRatesViewBody ? window.otherAmenitiesRatesViewBody.dayrateavail : window.otherAmenityGet.dayrateavail,
          "dayratecost": window.otherAmenitiesRatesViewBody ? window.otherAmenitiesRatesViewBody.dayratecost : window.otherAmenityGet.dayratecost,
          "dayrateprop": window.otherAmenitiesRatesViewBody ? window.otherAmenitiesRatesViewBody.dayrateprop : window.otherAmenityGet.dayrateprop,
          "dayratenote": window.otherAmenitiesRatesViewBody ? window.otherAmenitiesRatesViewBody.dayratenote : window.otherAmenityGet.dayratenote,
          "guestlaundry": window.otherAmenitiesMiscellaneousBody ? window.otherAmenitiesMiscellaneousBody.guestlaundry : window.otherAmenityGet.guestlaundry,
          "guestlaundryfee": window.otherAmenitiesMiscellaneousBody ? window.otherAmenitiesMiscellaneousBody.guestlaundryfee : window.otherAmenityGet.guestlaundryfee,
          "guestlaundryhours": window.otherAmenitiesMiscellaneousBody ? window.otherAmenitiesMiscellaneousBody.guestlaundryhours : "",
          "foodtakeaway": window.otherAmenitiesMiscellaneousBody ? window.otherAmenitiesMiscellaneousBody.foodtakeaway : window.otherAmenityGet.foodtakeaway,
          "ccaccessavail": window.otherAmenitiesMiscellaneousBody ? window.otherAmenitiesMiscellaneousBody.ccaccessavail : window.otherAmenityGet.ccaccessavail,
          "ccaccesscost": window.otherAmenitiesMiscellaneousBody ? window.otherAmenitiesMiscellaneousBody.ccaccesscost : window.otherAmenityGet.ccaccesscost,
          "ccaccessprop": window.otherAmenitiesMiscellaneousBody ? window.otherAmenitiesMiscellaneousBody.ccaccessprop : window.otherAmenityGet.ccaccessprop,
          "ccaccessnotes": window.otherAmenitiesMiscellaneousBody ? window.otherAmenitiesMiscellaneousBody.ccaccessnotes : window.otherAmenityGet.ccaccessnotes,
          "cribavail": window.otherAmenitiesMiscellaneousBody ? window.otherAmenitiesMiscellaneousBody.cribavail : window.otherAmenityGet.cribavail,
          "cribcost": window.otherAmenitiesMiscellaneousBody ? window.otherAmenitiesMiscellaneousBody.cribcost : window.otherAmenityGet.cribcost,
          "cribprop": window.otherAmenitiesMiscellaneousBody ? window.otherAmenitiesMiscellaneousBody.cribprop : window.otherAmenityGet.cribprop,
          "cribnotes": window.otherAmenitiesMiscellaneousBody ? window.otherAmenitiesMiscellaneousBody.cribnotes : window.otherAmenityGet.cribnotes
       }
    }
 }
 const body_security = {
    "supplier": session.supplier,
    "propertyId": session.propertyId,
    "property":{
       "otheramenities":{
          "accessiblewashbasin": window.otherAmenitiesExtra ? window.otherAmenitiesExtra.accessiblewashbasin : window.otherAmenityGet.accessiblewashbasin,
          "loweredsink": window.otherAmenitiesExtra ? window.otherAmenitiesExtra.loweredsink : window.otherAmenityGet.loweredsink,
          "loweredviewportdoor": window.otherAmenitiesExtra ? window.otherAmenitiesExtra.loweredviewportdoor : window.otherAmenityGet.loweredviewportdoor
       }
    }
 }
 const general_body = {
    "supplier": session.supplier,
    "propertyId": session.propertyId,
    "property":{
      "otheramenities":{
        "roomentrance": window.otherAmenitiesGeneral ? window.otherAmenitiesGeneral.roomentrance : window.otherAmenityGet.roomentrance,
        "airfilter": window.otherAmenitiesGeneral ? window.otherAmenitiesGeneral.airfilter : window.otherAmenityGet.airfilter,
        "hypoallergicroom": window.otherAmenitiesGeneral ? window.otherAmenitiesGeneral.hypoallergicroom : window.otherAmenityGet.hypoallergicroom,
        "housekeepingtype": window.otherAmenitiesGeneral ? window.otherAmenitiesGeneral.housekeepingtype : window.otherAmenityGet.housekeepingtype,
        "housekeepingfrequency": window.otherAmenitiesGeneral ? window.otherAmenitiesGeneral.housekeepingfrequency : window.otherAmenityGet.housekeepingfrequency,
        "housekeepingdailyfee": window.otherAmenitiesGeneral ? window.otherAmenitiesGeneral.housekeepingdailyfee : window.otherAmenityGet.housekeepingdailyfee,
      }
    }
  }
  const closures_body = {
    "supplier": session.supplier,
    "propertyId": session.propertyId,
    "property":{
       "otheramenities":{
        "otheramenityid" : window.otherAmenityGet.otheramenityid,
        "closures": window.otherAmenitiesHotelBody ? window.otherAmenitiesHotelBody : []
       }
    }
 }
 try {
  const InfoPost = new ApiCallsFactory('/otheramenity/info', session.token, body)
  const securityPost = new ApiCallsFactory('/otheramenity/security', session.token, body_security)
  const generalPost = new ApiCallsFactory('/otheramenity/general', session.token, general_body)
  const closurePost = new ApiCallsFactory('/otheramenity/closures', session.token, closures_body)
  await InfoPost.postData()
  await securityPost.postData()
  await generalPost.postData()
  await closurePost.postData()
 } catch (error) {
   return error
 }
}

const getData = async () => {
  const get_session = new LocalPersistence('session')
  const session = await get_session.getSessionPersistence()
  // getting data from the server
  const basicInfo = new ApiCallsFactory(`/property/otheramenities?supplier=${session.supplier}&propertyid=${session.propertyId}`, session.token)
  const resData: any =  await basicInfo.getData()
  window.otherAmenityGet = resData.property.otheramenities
  return resData.property.otheramenities
}

export { 
  post,
  getData,
}
 